import _ from 'lodash';
import * as actions from 'app/actions/support';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_REFERRAL_PAGE: {
      return Object.assign({}, state, {
        referralPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_REFERRAL_INFO: {
      return Object.assign({}, state, {
        referralInfo: _.get(action, 'result'),
      });
    }
    case actions.PAYMENT_REQUEST_ATTEMPT: {
      return Object.assign({}, state, {
        status: _.get(action, 'result.status'),
      });
    }
    case actions.PAYPAL_REQUEST: {
      return Object.assign({}, state, {
        status: _.get(action, 'result.status'),
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/support.js